import React from "react";
import { useWatch } from "react-hook-form";

import { i18, trb } from "@utilities";
import { InputFormField, RadioFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper, HalfWidthInputWrapper, StepperFormRow } from "@components";
import { yesNo } from "@config/StepperForm";

export const ClientBasicBusiness = ({ control, unregister }) => {
  const requireBusinessLicense = useWatch({
    control,
    name: "clientProfile.0.data.requireBusinessLicense"
  });
  const amlRulesLeg = useWatch({
    control,
    name: "clientProfile.0.data.amlRulesLeg"
  });

  const unregisterBusinessLicense = e => {
    if (e.target.value === 1) return;
    unregister("clientProfile.0.data.businessLicenseNumber");
  };

  const unregisterAmlRules = e => {
    if (e.target.value === 1) return;
    unregister([
      "clientProfile.0.data.amlProcedure",
      "clientProfile.0.data.amlCheckInSancLis",
      "clientProfile.0.data.amlOfficerEmail",
      "clientProfile.0.data.amlOfficerNameSur",
      "clientPhone.0.data.amlOfficerPhone"
    ]);
  };

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.ClientBasicBusiness)}</p>
      </FullWidthInputWrapper>
      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name="clientBasicBusiness.0.clientBasicBusinessType"
        defaultValue="CBBSN1"
        className="d-none"
      />

      <FullWidthInputWrapper>
        <InputFormField
          control={control}
          title={trb(i18.Labels.ClientServicesDescription)}
          name="clientProfile.0.data.clientServicesDescription"
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientProfile.0.data.requireBusinessLicense"
          title={trb(i18.Labels.RequireBusinessLicense)}
          options={yesNo}
          optionsLabel="label"
          optionsValue="value"
          defaultValue={0}
          onChange={unregisterBusinessLicense}
          translationGroup={i18.Labels}
        />
      </FullWidthInputWrapper>

      {(requireBusinessLicense === 1 || requireBusinessLicense === "1") && (
        <FullWidthInputWrapper>
          <InputFormField
            control={control}
            title={trb(i18.Labels.BusinessLicenseNumber)}
            name="clientProfile.0.data.businessLicenseNumber"
          />
        </FullWidthInputWrapper>
      )}

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientProfile.0.data.amlRulesLeg"
          title={trb(i18.Labels.AmlRulesLeg)}
          options={yesNo}
          optionsLabel="label"
          optionsValue="value"
          onChange={unregisterAmlRules}
          translationGroup={i18.Labels}
        />
      </FullWidthInputWrapper>

      {(amlRulesLeg === 1 || amlRulesLeg === "1") && (
        <>
          <FullWidthInputWrapper>
            <RadioFormField
              control={control}
              name="clientProfile.0.data.amlProcedure"
              title={trb(i18.Labels.AmlProcedure)}
              options={yesNo}
              optionsLabel="label"
              optionsValue="value"
              defaultValue={0}
              translationGroup={i18.Labels}
            />
          </FullWidthInputWrapper>

          <FullWidthInputWrapper>
            <InputFormField
              control={control}
              title={trb(i18.Labels.AmlCheckInSancLis)}
              name="clientProfile.0.data.amlCheckInSancLis"
            />
          </FullWidthInputWrapper>

          <FullWidthInputWrapper>
            <p className="pl-3 form-part-additional-info">{trb(i18.Labels.AmlOfficer)}</p>
          </FullWidthInputWrapper>

          <FullWidthInputWrapper>
            <InputFormField
              control={control}
              title={trb(i18.Labels.AmlOfficerEmail)}
              name="clientProfile.0.data.amlOfficerEmail"
            />
          </FullWidthInputWrapper>

          <HalfWidthInputWrapper>
            <InputFormField
              control={control}
              title={trb(i18.Labels.AmlOfficerNameSur)}
              name="clientProfile.0.data.amlOfficerNameSur"
            />
          </HalfWidthInputWrapper>

          <HalfWidthInputWrapper>
            <InputFormField
              control={control}
              title={trb(i18.Labels.AmlOfficerPhone)}
              name="clientPhone.0.data.amlOfficerPhone"
              type="tel"
              defaultValue="+"
            />
          </HalfWidthInputWrapper>
        </>
      )}
    </StepperFormRow>
  );
};
